import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import el from './el.json';
import en from './en.json';

export type AppLanguage = 'el' | 'en';
export const SUPPORTED_LANGUAGES: AppLanguage[] = ['el', 'en'];
export const LANGUAGE_STORAGE_KEY = 'heirapsia_language';

i18n.use(initReactI18next).init({
  resources: {
    el: { translation: el },
    en: { translation: en },
  },
  lng: 'el',
  fallbackLng: 'el',
  interpolation: { escapeValue: false },
  compatibilityJSON: 'v4',
});

export default i18n;
